import { useTranslation } from "react-i18next";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import data from "fixtureData/userGuide/index";
export const getStringName = (name: string) => {
  switch (name) {
    case "begin":
      return "begin";
    case "wallet":
      return "wallet";
    case "trade":
      return "trade";
    case "panel":
      return "panel";
    default:
      return "begin";
  }
};

const Guide = (props: any) => {
  const { t } = useTranslation();
  const currentId = getStringName(props.match.params.id);
  const parts = props.match.params.id.split("");
  const lastItem = parts[parts.length - 1];

  return (
    <div>
      <StaticHeaderInfo>
        <span className="text-light fs-2 fw-bold ">{t("user manual")}</span>
      </StaticHeaderInfo>
      <Container>
        {data[currentId].map((item) => {
          return (
            <Row className="pt-3" id={""}>
              <Col xs="12">
                <Card className="shadow border-radius-1">
                  <CardBody>
                    <Row>
                      <Col xs="12">
                        <CardTitle>
                          <span className="title-bordre-bottom ">
                            {t(item.heroTitle)}
                          </span>
                        </CardTitle>
                        <p className="mt-4">{t(item.subTitle)}</p>
                        <div className="bullet-point list">
                          <ul>
                            {item.body.map((item) => (
                              <li>{t(item)}</li>
                            ))}
                          </ul>
                        </div>
                        <p className="my-3">{t(item.content)}</p>
                      </Col>
                      <Col
                        xs="12"
                        className="d-flex justify-content-center my-2"
                      >
                        <iframe
                          src={item.video}
                          width="650"
                          height="350"
                          className="border-radius-1"
                        ></iframe>
                      </Col>
                    </Row>
                    <Row className="pt-5 none-padding">
                      <Col xs="12">
                        <p>{t(item.firstContent)}</p>
                        <p>
                          {t(
                            "Wherever you encounter problems in performing the above steps, you can contact our support team 24/7."
                          )}
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
      </Container>
    </div>
  );
};
export default Guide;
